import React, { useState, useEffect, useRef } from 'react';

// ⚠️ REPLACE THESE WITH YOUR ACTUAL VALUES
const FORMSPREE_ID = 'mreobnzq';
const WHATSAPP_LINK = "https://whatsapp.com/channel/0029VbCN7FC2kNFm1zYLtw1H";

const cities = ['Accra', 'Kumasi', 'Tamale', 'Cape Coast', 'Takoradi', 'Tema', 'Other'];
const specialties = [
	"Kaba & Slit",
	"Kaftan",
	"Suits",
	"Agbada",
	"kids Wears",
	"Others",
];
const clientOrders = [
	"Kaba & Slit",
	"Kaftan",
	"Suits",
	"Agbada",
	"kids Wears",
	"Others",
];

function FieldLabel({ children, required }) {
  return (
    <label style={{ fontSize: '0.82rem', fontWeight: '500', color: 'var(--text-muted)', letterSpacing: '0.05em', textTransform: 'uppercase', marginBottom: '6px', display: 'block' }}>
      {children} {required && <span style={{ color: 'var(--gold)' }}>*</span>}
    </label>
  );
}

function CheckItem({label, checked, onChange}) {
	return (
		<label
			className={`check-label ${checked ? "checked" : ""}`}
			style={{
				cursor: "pointer",
				display: "flex",
				alignItems: "center",
				gap: "10px",
			}}
		>
			<div
				style={{
					width: "18px",
					height: "18px",
					border: "2px solid var(--gold)",
					borderRadius: "4px",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					background: checked ? "var(--gold)" : "transparent",
					transition: "all 0.2s ease",
				}}
			>
				{checked && (
					<span
						style={{
							color: "#000",
							fontSize: "12px",
							fontWeight: "bold",
							transform: "scale(1)",
							transition: "transform 0.15s ease",
						}}
					>
						✓
					</span>
				)}
			</div>

			{/* Hidden real input for accessibility */}
			<input
				type="checkbox"
				checked={checked}
				onChange={onChange}
				style={{display: "none"}}
			/>

			<span>{label}</span>
		</label>
	);
}

function RadioItem({label, checked, onChange, name}) {
	return (
		<label
			className={`radio-label ${checked ? "checked" : ""}`}
			style={{
				cursor: "pointer",
				display: "flex",
				alignItems: "center",
				gap: "10px",
			}}
		>
			{/* Custom radio */}
			<div
				style={{
					width: "18px",
					height: "18px",
					border: "2px solid var(--gold)",
					borderRadius: "50%",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					background: "transparent",
					transition: "all 0.2s ease",
				}}
			>
				{checked && (
					<div
						style={{
							width: "8px",
							height: "8px",
							borderRadius: "50%",
							background: "var(--gold)",
						}}
					/>
				)}
			</div>

			{/* Hidden real input */}
			<input
				type="radio"
				name={name}
				checked={checked}
				onChange={onChange}
				style={{display: "none"}}
			/>

			<span>{label}</span>
		</label>
	);
}

function CheckGrid({ items, values, onChange }) {
  return (
    <div className="grid-2" style={{ gap: '8px' }}>
      {items.map(item => (
        <CheckItem key={item} label={item} checked={values.includes(item)} onChange={() => {
          const updated = values.includes(item) ? values.filter(v => v !== item) : [...values, item];
          onChange(updated);
        }} />
      ))}
    </div>
  );
}

export default function WaitlistForm({ preselectedRole }) {
  const formRef = useRef(null);
  const [role, setRole] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [charCount, setCharCount] = useState(0);
  const nameRef = useRef(null);
  const emailRef = useRef(null);
  const phoneRef = useRef(null);
  const cityRef = useRef(null);
  const roleRef = useRef(null);

  // Shared fields
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [city, setCity] = useState('');

  // Tailor fields
  const [experience, setExperience] = useState('');
  const [tailorSpecialties, setTailorSpecialties] = useState([]);
  const [onlineOrders, setOnlineOrders] = useState('');
  const [howFound, setHowFound] = useState([]);
  const [challenges, setChallenges] = useState([]);
  const [monthlyOrders, setMonthlyOrders] = useState('');
  const [hasSmartphone, setHasSmartphone] = useState('');
  const [useMobileApp, setUseMobileApp] = useState('');
  const [tailorNote, setTailorNote] = useState('');

  // Client fields
  const [usageFreq, setUsageFreq] = useState('');
  const [clientOrdering, setClientOrdering] = useState([]);
  const [frustrations, setFrustrations] = useState([]);
  const [clientFindTailor, setClientFindTailor] = useState([]);
  const [differentCity, setDifferentCity] = useState('');
  const [budget, setBudget] = useState('');
  const [trustFactors, setTrustFactors] = useState([]);
  const [clientNote, setClientNote] = useState('');

  useEffect(() => {
    if (preselectedRole) {
      setRole(preselectedRole);
      setTimeout(() => formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100);
    }
  }, [preselectedRole]);

  const validate = () => {
    const e = {};
    if (!role) e.role = 'Please select your role';
    if (!name.trim()) e.name = 'Full name is required';
    if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) e.email = 'Valid email is required';
    if (!phone.trim()) e.phone = 'Phone number is required';
    if (!city) e.city = 'Please select your city';
    return e;
  };

const scrollToError = (errs) => {
	const scroll = (ref) => {
		ref.current?.scrollIntoView({behavior: "smooth", block: "center"});
		ref.current?.focus?.();
	};

	if (errs.role) return scroll(roleRef);
	if (errs.name) return scroll(nameRef);
	if (errs.email) return scroll(emailRef);
	if (errs.phone) return scroll(phoneRef);
	if (errs.city) return scroll(cityRef);
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
	if (Object.keys(errs).length > 0) {
		setErrors(errs);
		scrollToError(errs);
		return;
	}

    const payload = {
      _subject: 'New Kaftora Waitlist Signup',
      role,
      name, email, phone, city,
      ...(role === 'tailor' ? {
        experience, tailor_specialties: tailorSpecialties.join(', '),
        takes_online_orders: onlineOrders,
        how_clients_find_me: howFound.join(', '),
        biggest_challenges: challenges.join(', '),
        monthly_orders: monthlyOrders,
        has_smartphone: hasSmartphone,
        would_use_mobile_app: useMobileApp,
        additional_notes: tailorNote,
      } : {
        usage_frequency: usageFreq,
        what_i_order: clientOrdering.join(', '),
        frustrations: frustrations.join(', '),
        how_i_find_tailors: clientFindTailor.join(', '),
        order_different_city: differentCity,
        typical_budget: budget,
        trust_factors: trustFactors.join(', '),
        additional_notes: clientNote,
      }),
    };

    try {
      const res = await fetch(`https://formspree.io/f/${FORMSPREE_ID}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (res.ok) {
        setSubmitted(true);
      } else {
        alert('Something went wrong. Please try again.');
      }
    } catch {
      alert('Network error. Please try again.');
    }
    setLoading(false);
  };

  return (
    <section id="waitlist" style={{
      padding: '100px 24px',
      background: 'var(--surface)',
      position: 'relative', overflow: 'hidden',
    }}>
      <div style={{
        position: 'absolute', top: 0, left: 0, right: 0, height: '1px',
        background: 'linear-gradient(90deg, transparent, rgba(240,165,0,0.4), transparent)',
      }} />

      <div style={{ maxWidth: '640px', margin: '0 auto' }} ref={formRef}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '48px' }}>
          <p style={{ fontSize: '0.75rem', letterSpacing: '0.18em', textTransform: 'uppercase', color: 'var(--gold)', fontWeight: '500', marginBottom: '14px' }}>
            Join the Waitlist
          </p>
          <h2 style={{
            fontFamily: 'var(--font-display)',
            fontSize: 'clamp(2rem, 4.5vw, 3.2rem)',
            fontWeight: '600', color: '#fff', marginBottom: '14px',
          }}>
            Be first when we launch
          </h2>
          {submitted ? <p> </p>: <p style={{ color: 'var(--text-muted)', fontSize: '1rem' }}>
            Tell us a little about yourself. Takes 2 minutes.
          </p>}
        </div>

        {submitted ? (
          <div style={{
            background: 'rgba(240,165,0,0.08)',
            border: '1px solid rgba(240,165,0,0.35)',
            borderRadius: '16px', padding: '48px',
            textAlign: 'center',
            animation: 'fadeIn 0.6s ease',
          }}>
            <div style={{ fontSize: '3rem', marginBottom: '20px' }}>🎉</div>
            <h3 style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', fontWeight: '600', color: '#fff', marginBottom: '12px' }}>
              You're on the list!
            </h3>
            <p style={{ color: 'var(--text-muted)', fontSize: '1rem', marginBottom: '24px' }}>
              We'll be in touch soon. Join the Kaftora WhatsApp plaform.
            </p>
            <p style={{ color: 'var(--gold)', fontSize: '0.9rem' }}>Luxury In Every Thread.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} noValidate>
            {/* Role selector */}
            <div ref={roleRef} style={{ marginBottom: '32px' }}>
              <FieldLabel required>I am a...</FieldLabel>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginTop: '8px' }}>
                {[
                  { val: 'client', emoji: '👗', label: "I'm a Client", sub: 'I want custom outfits' },
                  { val: 'tailor', emoji: '✂️', label: "I'm a Tailor", sub: 'I make custom outfits' },
                ].map(({ val, emoji, label, sub }) => (
                  <button type="button" key={val} onClick={() => { setRole(val); setErrors(e => ({ ...e, role: '' })); }} style={{
                    background: role === val ? 'rgba(240,165,0,0.1)' : 'var(--surface2)',
                    border: `2px solid ${role === val ? 'var(--gold)' : 'var(--border)'}`,
                    borderRadius: '12px', padding: '20px 16px',
                    cursor: 'pointer', textAlign: 'center',
                    transition: 'all 0.22s ease', color: '#fff',
                    fontFamily: 'var(--font-sans)',
                  }}
                  onMouseEnter={e => { if (role !== val) e.currentTarget.style.borderColor = 'rgba(240,165,0,0.4)'; }}
                  onMouseLeave={e => { if (role !== val) e.currentTarget.style.borderColor = 'var(--border)'; }}
                  >
                    <div style={{ fontSize: '2rem', marginBottom: '8px' }}>{emoji}</div>
                    <div style={{ fontWeight: '600', fontSize: '0.95rem', marginBottom: '4px' }}>{label}</div>
                    <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>{sub}</div>
                  </button>
                ))}
              </div>
              {errors.role && <p className="field-error">{errors.role}</p>}
            </div>

            {/* Divider */}
            {role && (
              <div style={{ height: '1px', background: 'var(--border)', marginBottom: '28px' }} />
            )}

            {/* Shared fields */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', marginBottom: role ? '28px' : '0' }}>
              <div className="field-group">
                <FieldLabel required>Full Name</FieldLabel>
                <input ref={nameRef} type="text" placeholder="Ama Owusu" value={name} onChange={e => setName(e.target.value)} />
                {errors.name && <p className="field-error">{errors.name}</p>}
              </div>
              <div className="field-group">
                <FieldLabel required>Email Address</FieldLabel>
                <input ref={emailRef} type="email" placeholder="ama@example.com" value={email} onChange={e => setEmail(e.target.value)} />
                {errors.email && <p className="field-error">{errors.email}</p>}
              </div>
              <div className="field-group">
                <FieldLabel required>Phone / WhatsApp Number</FieldLabel>
                <input ref={phoneRef} type="tel" placeholder="+233 XX XXX XXXX" value={phone} onChange={e => setPhone(e.target.value)} />
                {errors.phone && <p className="field-error">{errors.phone}</p>}
              </div>
              <div className="field-group">
                <FieldLabel required>City</FieldLabel>
                <div style={{ position: 'relative' }}>
                  <select ref={cityRef} value={city} onChange={e => setCity(e.target.value)} style={{ paddingRight: '36px' }}>
                    <option value="">Select your city</option>
                    {cities.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                  <span style={{ position: 'absolute', right: '14px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: 'var(--text-muted)', fontSize: '0.75rem' }}>▼</span>
                </div>
                {errors.city && <p className="field-error">{errors.city}</p>}
              </div>
            </div>

            {/* Tailor-specific fields */}
            {role === 'tailor' && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', animation: 'fadeIn 0.4s ease' }}>
                <div style={{ height: '1px', background: 'rgba(240,165,0,0.2)' }} />
                <p style={{ fontSize: '0.8rem', color: 'var(--gold)', letterSpacing: '0.1em', textTransform: 'uppercase', fontWeight: '500' }}>✂️ About Your Tailoring Business</p>

                <div className="field-group">
                  <FieldLabel>Years of Experience</FieldLabel>
                  <div style={{ position: 'relative' }}>
                    <select value={experience} onChange={e => setExperience(e.target.value)} style={{ paddingRight: '36px' }}>
                      <option value="">Select experience</option>
                      {['Less than 1 year', '1–3 years', '3–5 years', '5–10 years', '10+ years'].map(o => <option key={o} value={o}>{o}</option>)}
                    </select>
                    <span style={{ position: 'absolute', right: '14px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: 'var(--text-muted)', fontSize: '0.75rem' }}>▼</span>
                  </div>
                </div>

                <div className="field-group">
                  <FieldLabel>Your Specialties</FieldLabel>
                  <CheckGrid items={specialties} values={tailorSpecialties} onChange={setTailorSpecialties} />
                </div>

                <div className="field-group">
                  <FieldLabel>Do you currently take orders online?</FieldLabel>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {['Yes', 'No', 'Sometimes'].map(o => (
                      <RadioItem key={o} label={o} name="online_orders" checked={onlineOrders === o} onChange={() => setOnlineOrders(o)} />
                    ))}
                  </div>
                </div>

                <div className="field-group">
                  <FieldLabel>How do clients currently find you?</FieldLabel>
                  <CheckGrid items={['Instagram', 'Facebook', 'Word of mouth', 'Walk-ins', 'WhatsApp', 'Other']} values={howFound} onChange={setHowFound} />
                </div>

                <div className="field-group">
                  <FieldLabel>Biggest challenges in your business</FieldLabel>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {[
                      'Getting consistent clients',
                      'Clients who ghost or don\'t pay',
                      'Managing multiple orders at once',
                      'Building trust with new clients',
                      'Pricing my work confidently',
                      'Growing beyond my current location',
                    ].map(o => (
                      <CheckItem key={o} label={o} checked={challenges.includes(o)} onChange={() => setChallenges(p => p.includes(o) ? p.filter(v => v !== o) : [...p, o])} />
                    ))}
                  </div>
                </div>

                <div className="field-group">
                  <FieldLabel>Monthly orders (approximately)</FieldLabel>
                  <div style={{ position: 'relative' }}>
                    <select value={monthlyOrders} onChange={e => setMonthlyOrders(e.target.value)} style={{ paddingRight: '36px' }}>
                      <option value="">Select range</option>
                      {['Less than 5', '5–10', '10–20', '20–30', '30+'].map(o => <option key={o} value={o}>{o}</option>)}
                    </select>
                    <span style={{ position: 'absolute', right: '14px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: 'var(--text-muted)', fontSize: '0.75rem' }}>▼</span>
                  </div>
                </div>

                <div className="field-group">
                  <FieldLabel>Do you have a smartphone?</FieldLabel>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    {['Yes', 'No'].map(o => (
                      <RadioItem key={o} label={o} name="smartphone" checked={hasSmartphone === o} onChange={() => setHasSmartphone(o)} />
                    ))}
                  </div>
                </div>

                <div className="field-group">
                  <FieldLabel>Would you use a mobile app to manage your orders?</FieldLabel>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {['Definitely', 'Maybe', 'No'].map(o => (
                      <RadioItem key={o} label={o} name="mobile_app" checked={useMobileApp === o} onChange={() => setUseMobileApp(o)} />
                    ))}
                  </div>
                </div>

                <div className="field-group">
                  <FieldLabel>Anything you want us to know? <span style={{ color: 'var(--text-dim)', fontWeight: '300', textTransform: 'none', letterSpacing: 0 }}>(optional)</span></FieldLabel>
                  <textarea
                    placeholder="Tell us about your work, your dreams for your business, or any questions..."
                    value={tailorNote}
                    maxLength={300}
                    onChange={e => { setTailorNote(e.target.value); setCharCount(e.target.value.length); }}
                  />
                  <p style={{ fontSize: '0.75rem', color: 'var(--text-dim)', textAlign: 'right' }}>{tailorNote.length}/300</p>
                </div>
              </div>
            )}

            {/* Client-specific fields */}
            {role === 'client' && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', animation: 'fadeIn 0.4s ease' }}>
                <div style={{ height: '1px', background: 'rgba(240,165,0,0.2)' }} />
                <p style={{ fontSize: '0.8rem', color: 'var(--gold)', letterSpacing: '0.1em', textTransform: 'uppercase', fontWeight: '500' }}>👗 About Your Fashion Needs</p>

                <div className="field-group">
                  <FieldLabel>How often do you use a tailor?</FieldLabel>
                  <div style={{ position: 'relative' }}>
                    <select value={usageFreq} onChange={e => setUsageFreq(e.target.value)} style={{ paddingRight: '36px' }}>
                      <option value="">Select frequency</option>
                      {['Multiple times a year', 'Once a year', 'Occasionally', "I've never used one but want to"].map(o => <option key={o} value={o}>{o}</option>)}
                    </select>
                    <span style={{ position: 'absolute', right: '14px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: 'var(--text-muted)', fontSize: '0.75rem' }}>▼</span>
                  </div>
                </div>

                <div className="field-group">
                  <FieldLabel>What do you usually order?</FieldLabel>
                  <CheckGrid items={clientOrders} values={clientOrdering} onChange={setClientOrdering} />
                </div>

                <div className="field-group">
                  <FieldLabel>Biggest frustrations when finding a tailor</FieldLabel>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {[
                      'Hard to find good tailors',
                      "Can't see their work upfront",
                      'Worried about paying and not getting the outfit',
                      'Tailors miss deadlines',
                      'Inconsistent quality',
                      'No way to compare prices',
                    ].map(o => (
                      <CheckItem key={o} label={o} checked={frustrations.includes(o)} onChange={() => setFrustrations(p => p.includes(o) ? p.filter(v => v !== o) : [...p, o])} />
                    ))}
                  </div>
                </div>

                <div className="field-group">
                  <FieldLabel>How do you currently find tailors?</FieldLabel>
                  <CheckGrid items={['Friends & family referrals', 'Instagram', 'Facebook', 'Walk past their shop', 'WhatsApp groups', 'Other']} values={clientFindTailor} onChange={setClientFindTailor} />
                </div>

                <div className="field-group">
                  <FieldLabel>Would you order from a tailor in a different city if quality was guaranteed?</FieldLabel>
                  <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    {['Yes', 'No', 'Maybe'].map(o => (
                      <RadioItem key={o} label={o} name="diff_city" checked={differentCity === o} onChange={() => setDifferentCity(o)} />
                    ))}
                  </div>
                </div>

                <div className="field-group">
                  <FieldLabel>Typical budget for an outfit</FieldLabel>
                  <div style={{ position: 'relative' }}>
                    <select value={budget} onChange={e => setBudget(e.target.value)} style={{ paddingRight: '36px' }}>
                      <option value="">Select budget</option>
                      {['Under GH₵200', 'GH₵200–500', 'GH₵500–1000', 'GH₵1000–2000', 'GH₵2000+'].map(o => <option key={o} value={o}>{o}</option>)}
                    </select>
                    <span style={{ position: 'absolute', right: '14px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: 'var(--text-muted)', fontSize: '0.75rem' }}>▼</span>
                  </div>
                </div>

                <div className="field-group">
                  <FieldLabel>What would make you trust a tailor you've never used?</FieldLabel>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {[
                      'Verified customer reviews',
                      'Portfolio of past work',
                      'Escrow payment protection',
                      'Refund guarantee',
                      'Recommended by someone I know',
                    ].map(o => (
                      <CheckItem key={o} label={o} checked={trustFactors.includes(o)} onChange={() => setTrustFactors(p => p.includes(o) ? p.filter(v => v !== o) : [...p, o])} />
                    ))}
                  </div>
                </div>

                <div className="field-group">
                  <FieldLabel>Anything you want us to know? <span style={{ color: 'var(--text-dim)', fontWeight: '300', textTransform: 'none', letterSpacing: 0 }}>(optional)</span></FieldLabel>
                  <textarea
                    placeholder="Tell us about your style, your dream outfit, or what you need most from Kaftora..."
                    value={clientNote}
                    maxLength={300}
                    onChange={e => setClientNote(e.target.value)}
                  />
                  <p style={{ fontSize: '0.75rem', color: 'var(--text-dim)', textAlign: 'right' }}>{clientNote.length}/300</p>
                </div>
              </div>
            )}

            {/* Submit */}
            <div style={{ marginTop: '32px' }}>
              <button type="submit" disabled={loading} style={{
                width: '100%', padding: '18px',
                background: loading ? 'rgba(240,165,0,0.5)' : 'var(--gold)',
                color: '#000', border: 'none', borderRadius: '10px',
                fontSize: '1.05rem', fontWeight: '700',
                fontFamily: 'var(--font-sans)', cursor: loading ? 'not-allowed' : 'pointer',
                letterSpacing: '0.04em',
                transition: 'all 0.22s ease',
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
              }}
              onMouseEnter={e => { if (!loading) { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 12px 32px rgba(240,165,0,0.35)'; } }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
              >
                {loading ? (
                  <><span className="spinner" /> Processing...</>
                ) : (
                  <>Join the Waitlist →</>
                )}
              </button>
              <p style={{ textAlign: 'center', fontSize: '0.78rem', color: 'var(--text-dim)', marginTop: '12px' }}>
                🔒 We will never spam you or share your information.
              </p>
            </div>
          </form>
        )}

        {/* WhatsApp Community Card */}
        <div style={{
          marginTop: '48px',
          background: 'rgba(37,211,102,0.06)',
          border: '1px solid rgba(37,211,102,0.2)',
          borderRadius: '16px', padding: '36px',
          textAlign: 'center',
        }}>
          <div style={{ fontSize: '2.2rem', marginBottom: '12px' }}>💬</div>
          <h3 style={{
            fontFamily: 'var(--font-display)',
            fontSize: '1.6rem', fontWeight: '600',
            color: '#fff', marginBottom: '10px',
          }}>Join our WhatsApp Community</h3>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.925rem', marginBottom: '24px', lineHeight: '1.65', maxWidth: '420px', margin: '0 auto 24px' }}>
            Get updates, be part of early decisions, and connect with tailors and clients who are building something new.
          </p>
          <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" style={{
            display: 'inline-flex', alignItems: 'center', gap: '8px',
            background: '#25D366', color: '#fff',
            padding: '14px 32px', borderRadius: '8px',
            fontSize: '0.95rem', fontWeight: '600',
            fontFamily: 'var(--font-sans)', textDecoration: 'none',
            transition: 'all 0.22s ease',
          }}
          onMouseEnter={e => { e.currentTarget.style.background = '#1da851'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
          onMouseLeave={e => { e.currentTarget.style.background = '#25D366'; e.currentTarget.style.transform = 'translateY(0)'; }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/></svg>
            Join WhatsApp Platform →
          </a>
        </div>
      </div>
    </section>
  );
}
